module.exports = __webpack_public_path__ + "assets/img/DO_RaceType_Gallops-BLACK.8c054ad4.svg";